import React from 'react';

// Ícone radar sóbrio (inline SVG, sem lib). Herda a cor via currentColor.
const RadarIcon = ({ size = 26 }) => (
  <svg
    className="brand-icon"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" opacity="0.35" />
    <circle cx="12" cy="12" r="5.5" opacity="0.6" />
    <circle cx="12" cy="12" r="1.6" fill="currentColor" stroke="none" />
    <path d="M12 12 L19 7" />
  </svg>
);

export default RadarIcon;
